export default __webpack_public_path__ + "static/media/regulatory--end-of-maximum-speed-limit-120--g1.47e0a468.png";